// utils/AxiosToastError.js
import { toast } from "react-hot-toast";

export const AxiosToastError = (error) => {
  let message = "Something went wrong";

  if (error.response) {
    // Server responded with status code other than 2xx
    message = error.response.data?.message || error.response.statusText;
  } else if (error.request) {
    // Request was made but no response
    message = "No response from server. Please try again.";
  } else {
    // Something else triggered the error
    message = error.message;
  }

  toast.error(message);
};
